import React, { useState } from "react";
import DatePicker from 'react-datepicker'
import registerComponent from "../../utils/registeredComponent.js";
import duckify from "../../utils/duckify.jsx";
import { activities } from '../../ducks/index.js';
import UserActivityList from "./UserActivityList.jsx";

const Activities = ({ accessList, activityList, contactId, createUserActivity }) => {
  const [showAddNote, setShowAddNote] = useState(false)
  const [date, setDate] = useState(new Date())
  const [filterType, setFilterType] = useState('all')
  const [noteField, setNoteField] = useState('')
  const [activityField, setActivityField] = useState(activityList[0] ? activityList[0].value : '')
  const [accessField, setAccessField] = useState(accessList[0])

  const handleAddItemClick = () => {
    setShowAddNote(!showAddNote)
  }
  const handleSubmit = event => {
    event.preventDefault()
    const newNote = {
      contact_id: contactId,
      note: noteField,
      date,
      activity_id: activityField,
      access: accessField,
      created_at: new Date().toJSON()
    }

    createUserActivity(newNote)
      .then(() => {
        setActivityField(activityList[0] ? activityList[0].value : '')
        setDate(new Date())
        setNoteField('')
        setAccessField(accessList[0])
        setShowAddNote(false)
      })
      .catch(error => {
        if (error.response && error.response.status === 422) {
          Utility.displayFlashMessages({ error: error.errors });
        } else {
          Utility.displayFlashMessages({ error: 'An unexpected error occurred. Please try again later.' });
        }
      });
  }

  const updateDate = event => {
    setDate(event)
  }

  const cancelAddNote = event => {
    event.preventDefault()
    setShowAddNote(false)
  }

  return (
    <React.Fragment>
      {/* Header section*/}
      <div className="header">
        <div className="row">
          <div className="col-12">
            <h2>Recent Activity</h2>
            <i className="fa fa-plus-circle add-item-button" onClick={handleAddItemClick} />
          </div>
          <div className="col-12">
            <div className="text-end">
              <a href={`/contacts/${contactId}/history`} className="italic">See full activity history</a>
            </div>
          </div>
        </div>
      </div>

      <div className="helper-text">
        The most recently logged emails, notes, and other activities
      </div>

      {/* Add note section */}
      {showAddNote &&
        <div className="add-note">
          <div className="green">Add a recent activity</div>
          <div className="entry">
            <form className="form-horizontal" onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-4 inline-label">Note</div>
                <div className="col-20">
                  <textarea id="note-textarea" className="col-24 required body" onChange={e => setNoteField(e.target.value)}></textarea>
                </div>
              </div>

              <div className="row">
                <div className="col-4 inline-label">Activity Type</div>
                <div className="col-10">
                  <select name="activity" className="col-24 activity-name" onChange={e => setActivityField(e.target.value)}>
                    {activityList.map(activity => (
                      <option key={activity.value} value={activity.value}>{activity.text}</option>
                    ))}
                  </select>
                </div>
                <div className="col-2 offset-lg-4 inline-label">Date</div>
                <div className="col-4 note-details-date">
                  <DatePicker
                    name="date"
                    value={date}
                    selected={date}
                    dateFormat={global.I18n.date.formats.default_date_fns}
                    popperPlacement="top-end"
                    todayButton="Today"
                    onChange={updateDate}
                    className="col-24 date required"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-4 inline-label">Visible to</div>
                <div className="col-10">
                  <select name="access" id="" className="col-24 access" onChange={e => setAccessField(e.target.value)} >
                    {accessList.map(access => (
                      <option key={access} value={access}>{access}</option>
                    ))}
                  </select>
                </div>
                <div className="col-4 offset-lg-6">
                  <div className="row">
                    <button className="col-12 btn btn-primary" disabled={noteField.length === 0}>
                      <i className="fa fa-check"></i>
                    </button>
                    <button className="col-12 btn cancel" onClick={cancelAddNote}>
                      <i className="fa fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>

            </form>
          </div>
        </div>
      }
      
      {/* Tabs */}
      <div className="row">
        <div className="col-auto left filter-labels">Show:</div>
        <div className="col-auto filters left">
          <div className={`btn all ${filterType === 'all' ? 'selected-all' : 'all'}`} onClick={() => setFilterType('all')}>
            <span>All</span>
          </div>
          <div className={`btn teal ${filterType === 'note' ? 'selected-note' : 'note'}`} onClick={() => setFilterType('note')}>
            <i className="fa fa-edit"></i>
            <span>Notes</span>
          </div>
          <div className={`btn blue ${filterType === 'activity' ? 'selected-activity' : 'activity'}`} onClick={() => setFilterType('activity')}>
            <i className="fa fa-share"></i>
            <span>Activities</span>
          </div>
          <div className={`btn green ${filterType === 'email' ? "selected-email" : "email"}`} onClick={() => setFilterType('email')}>
            <i className="fa fa-envelope"></i>
            <span>Emails</span>
          </div>
        </div>
      </div>

      {/* List of User Activity */}
      <UserActivityList
        accessList={accessList}
        activityList={activityList}
        filters={filterType}
        contactId={contactId}
        handleAddItemClick={handleAddItemClick}
      />

      <div className="row">
        <div className="col-12"></div>
        <div className="col-12">
          <div className="text-end">
            <a href={`/contacts/${contactId}/history`} className="italic">See full activity history</a>
          </div>
        </div>
      </div>

    </React.Fragment>
  )
}

const mapDispatchToProps = (dispatch) => {
  return {
    createUserActivity: (item) => dispatch(activities.actions.create(item))
      .then(() => dispatch(activities.actions.markDirty()))
      .catch(error => {
        // Ensure the error is propagated
        return Promise.reject(error);
      })
  }
}

export default registerComponent("Activities")(duckify(() => ({}), () => { }, mapDispatchToProps)(Activities))
